import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CURRENT_APP_VERSION } from './utils/app-version';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <App />,
);

reportWebVitals();
checkAppVersion();

async function checkAppVersion() {
  try {
    const apiUrl = process.env.REACT_APP_API_URL;
    const response = await fetch(`${apiUrl}/app_version/web/get_latest`);
    const version = await response.json();
    if (version?.versionCode !== CURRENT_APP_VERSION) {
      window.location.href = `${window.location.href}?t=${new Date().getTime()}`;
    }
    console.log(`You are using version : ${CURRENT_APP_VERSION}`);
    console.log(`Current Deploy Version is : ${version?.versionCode}`);
  } catch (error) {
    console.error('Failed to check version:', error);
  }
}
